import React, { ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';

import { FileType } from '../../../../types/common.types';

import { downloadFile } from '../../../../utils/util';

import { requestDownloadDocument } from '../../../../api/document/document.actions';

import TribeFiles from '../../../../components/screens/programme/tribe/tribe-files/TribeFiles';

type Props = {
  files: FileType[];
  deleteFile?: (file: FileType) => void;
  post?: boolean;
  comment?: boolean;
};

const TribeFilesContainer = ({ files, deleteFile, post = false, comment = false }: Props): ReactElement | null => {
  const dispatch: Dispatch = useDispatch();

  if (files.length === 0) return null;

  const downloadTribeFile = (file: FileType): void => {
    const { documentExternalReference, name } = file;

    dispatch(
      // @ts-expect-error TODO: Fix after adding types to document actions
      requestDownloadDocument({
        externalReference: documentExternalReference,
        onSuccess: (data: unknown): void => downloadFile(data, name)
      })
    );
  };

  return (
    <TribeFiles files={files} downloadFile={downloadTribeFile} deleteFile={deleteFile} comment={comment} post={post} />
  );
};

export default TribeFilesContainer;
